import { connect } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import { getOptionsHeadingText } from 'src/components/layouts/Standard/copy';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions as personalisationActions } from 'src/redux/personalisation/slice';
import { selectProduct } from 'src/redux/product/selectors';
import type { AppThunkDispatch } from 'src/redux/store';
import type {
  ProductOptionsDrawerDispatchProps,
  ProductOptionsDrawerStateProps,
} from './ProductOptionsDrawer';
import { ProductOptionsDrawer } from './ProductOptionsDrawer';

const mapStateToProps = (state: ReduxApplicationState): ProductOptionsDrawerStateProps => {
  const product = selectProduct(state);

  return {
    heading: getOptionsHeadingText(
      product.purchasable,
      product.options.length > 0,
      product.specialFeatures.personalisable,
    ),
    images: product.images,
    isOpen: state.personalisation.isPersonalisationOptionsExpanded,
    showValidationErrors: state.personalisation.shouldShowPersonalisationValidationErrors,
  };
};

const mapDispatchToProps = (dispatch: AppThunkDispatch): ProductOptionsDrawerDispatchProps => {
  return {
    onClose: () => dispatch(personalisationActions.setPersonalisationExpanded({ expanded: false })),
    onVisible: () => {
      sendGAEvent({
        event: 'custom_event',
        event_category: 'Product Personalisation',
        event_action: 'Impression',
        event_label: 'Initial Impression',
      });
    },
  };
};

export const ProductOptionsDrawerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductOptionsDrawer);
